/**
 * Appends the next collection page into #product-grid via Section Rendering API (?section_id=).
 * Expects [data-dlux-load-more] with data-next-url from main-collection-product-grid.
 *
 * IMPORTANT: section_id MUST be the section's runtime instance id (e.g.
 * "template--12345__product-grid") — read from #product-grid's data-id attribute.
 * Using the section TYPE ("main-collection-product-grid") causes Shopify to
 * re-render the section with its DEFAULT settings, which sets quick_add to "none"
 * and strips the Add to Bag / Email When Back buttons from every appended card.
 */
(function () {
  /*
   * Minimum time the loading state stays on screen.
   * The Section Rendering API usually answers in well under 200ms, which is
   * quick enough that the spinner appeared and vanished before it registered
   * as anything at all — it read as "the button does nothing, then products
   * appear". Holding the busy state briefly makes the feedback perceptible.
   * Kept short enough that it never feels like an artificial wait.
   */
  var MIN_BUSY_MS = 400;

  function withSectionParam(url, sectionId) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function init() {
    var btn = document.querySelector('[data-dlux-load-more]');
    if (!btn) return;

    var grid = document.getElementById('product-grid');
    if (!grid || grid.tagName !== 'UL') return;

    var sectionId = grid.getAttribute('data-id');
    if (!sectionId) {
      console.warn('[dlux-collection-load-more] #product-grid missing data-id; cannot call Section Rendering API safely');
      return;
    }

    var wrap = btn.closest('.dlux-collection-load-more');
    var endEl = wrap ? wrap.querySelector('[data-dlux-load-more-end]') : null;

    btn.addEventListener('click', function () {
      var next = btn.getAttribute('data-next-url');
      if (!next) return;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      var startedAt = Date.now();
      function afterMinimumBusy(fn) {
        var elapsed = Date.now() - startedAt;
        var wait = Math.max(0, MIN_BUSY_MS - elapsed);
        if (wait === 0) fn();
        else window.setTimeout(fn, wait);
      }

      // Journey: fire-and-forget click event so we can measure how often
      // visitors paginate past the first 16 cards on /collections/*.
      try {
        if (window.dluxJourney && typeof window.dluxJourney.track === 'function') {
          var collectionMatch = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
          var currentCount = grid.querySelectorAll(':scope > li').length;
          var nextPage = null;
          try {
            nextPage = new URL(next, window.location.origin).searchParams.get('page');
          } catch (e) { /* noop */ }
          window.dluxJourney.track('collection_load_more', {
            collection_handle: collectionMatch ? collectionMatch[1] : null,
            current_card_count: currentCount,
            next_page: nextPage ? Number(nextPage) : null,
          });
        }
      } catch (e) {
        /* noop */
      }

      fetch(withSectionParam(next, sectionId), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.statusText || String(res.status));
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (!newGrid) throw new Error('Missing #product-grid in section response');

          var items = newGrid.querySelectorAll(':scope > li');
          var newBtn = doc.querySelector('[data-dlux-load-more]');
          var nextUrl = newBtn ? newBtn.getAttribute('data-next-url') : null;

          afterMinimumBusy(function () {
            items.forEach(function (li) {
              grid.appendChild(li);
            });

            if (nextUrl) {
              btn.setAttribute('data-next-url', nextUrl);
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            } else {
              btn.remove();
              if (endEl) {
                endEl.hidden = false;
                endEl.classList.remove('visually-hidden');
              }
            }
          });
        })
        .catch(function (err) {
          console.error('[dlux-collection-load-more]', err);
          afterMinimumBusy(function () {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
